var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "min-height": "600px" } },
    [
      _c("PageHeader", {
        staticStyle: { position: "relative" },
        attrs: {
          title: _vm.displayName,
          "no-padding": "",
          loading: !_vm.loadingHasFinish,
        },
      }),
      _vm._v(" "),
      _c(
        "transition-group",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _c(
            "v-alert",
            {
              key: "alert",
              staticClass: "my-0",
              attrs: {
                outline: "",
                type: "error",
                value:
                  _vm.loadingHasFinish &&
                  !_vm.loading &&
                  !_vm.currentMonitoringFeature,
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _vm._v(
                  "\n        Oops, we couldn't load this location. Try again in a few minutes - let us know if it happens again!\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.loading
            ? _c("PageLoader", {
                key: "pageLoader",
                staticStyle: { position: "absolute", padding: "150px 0" },
                attrs: { resourceName: "location data" },
              })
            : !_vm.loading && _vm.currentMonitoringFeature
            ? _c(
                "div",
                { key: "main-container" },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        "active-class": "tabs-active-tab",
                        "slider-color": "info",
                        dark: "",
                        grow: "",
                        centered: "",
                      },
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab",
                        { attrs: { href: "#tab-summary", id: "mf-summary" } },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("assignment"),
                          ]),
                          _vm._v("Summary\n        "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.continuousAquarius
                      ]
                        ? _c(
                            "v-tab",
                            { attrs: { href: "#tab-time-series" } },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("mdi-clock"),
                              ]),
                              _vm._v("Time Series\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.discreteEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-sample-analyses",
                                id: "mf-discrete-data",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("mdi-water"),
                              ]),
                              _vm._v("Sample Analyses\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTabs.graphDashboard &&
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.discreteEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-graph-dash",
                                id: "mf-discrete-graph-dashboard",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Graph Dashboard\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.vegetativeMonitoringEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-specimen-info",
                                id: "mf-vegetativemonitoring-specimen-info",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Specimen Info\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.vegetativeMonitoringEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-plot-survey",
                                id: "mf-vegetativemonitoring-plot-query",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Plot Survey Query\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.vegetativeMonitoringEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-specimen-survey",
                                id: "mf-vegetativemonitoring-specimen-query",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Specimen Survey Query\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.surveysEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-survey-specimen-info",
                                id: "mf-survey-specimen-info",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Survey Specimen Info\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.surveysEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-survey-location-query",
                                id: "mf-survey-location-query",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Survey Location Query\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentFeatureDataSourceIndexByType[
                        _vm.SOURCE_TYPES.surveysEnvirodata
                      ]
                        ? _c(
                            "v-tab",
                            {
                              attrs: {
                                href: "#tab-survey-specimen-query",
                                id: "mf-survey-specimen-query",
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("poll"),
                              ]),
                              _vm._v("Survey Specimen Query\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.photos.length > 0
                        ? _c(
                            "v-tab",
                            { attrs: { href: "#tab-photos" } },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("image"),
                              ]),
                              _vm._v("Photos\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-summary" } },
                        [_c("Summary")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-time-series" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.continuousAquarius
                          ]
                            ? _c("ContinuousAquariusData")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-sample-analyses" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.discreteEnvirodata
                          ]
                            ? _c("DiscreteEnviroData")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-graph-dash" } },
                        [
                          _vm.showTabs.graphDashboard &&
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.discreteEnvirodata
                          ]
                            ? _c("DiscreteDataGraphDashboard")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-specimen-info" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.vegetativeMonitoringEnvirodata
                          ]
                            ? _c("VegetativeMonitoringSpecimenInfo")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-plot-survey" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.vegetativeMonitoringEnvirodata
                          ]
                            ? _c("VegetativeMonitoringPlotSurvey")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-specimen-survey" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.vegetativeMonitoringEnvirodata
                          ]
                            ? _c("VegetativeMonitoringSpecimenSurvey")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-survey-specimen-info" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.surveysEnvirodata
                          ]
                            ? _c("SurveySpecimenInfo")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-survey-location-query" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.surveysEnvirodata
                          ]
                            ? _c("SurveyLocationSurvey")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        { attrs: { value: "tab-survey-specimen-query" } },
                        [
                          _vm.currentFeatureDataSourceIndexByType[
                            _vm.SOURCE_TYPES.surveysEnvirodata
                          ]
                            ? _c("SurveySpecimenSurvey")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.photos.length > 0
                        ? _c(
                            "v-tab-item",
                            { attrs: { value: "tab-photos" } },
                            [
                              _vm.currentFeatureDataSourceIndexByType[
                                _vm.SOURCE_TYPES.continuousAquarius
                              ]
                                ? _c("Photos", {
                                    attrs: {
                                      photos: _vm.photos,
                                      stationName: _vm.displayName,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }